const tableCellUser = {
  photo: 'FOTO',
  Typography: 'Ningún resultado encontrado'
};

export default tableCellUser;
